var _rect, _path, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFiltersIcon = function SvgFiltersIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 80,
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7743 26.3602C19.2384 25.3758 20.2228 24.75 21.3126 24.75H51.6876C52.7775 24.75 53.7618 25.3758 54.2259 26.3602C54.69 27.3445 54.5493 28.5047 53.8603 29.3484L41.0001 45.0633V54C41.0001 54.8508 40.522 55.6313 39.7556 56.0109C38.9892 56.3906 38.0822 56.3133 37.4001 55.8L32.9001 52.425C32.3306 52.0031 32.0001 51.3352 32.0001 50.625V45.0633L19.1329 29.3414C18.4509 28.5047 18.3032 27.3375 18.7743 26.3602Z",
    fill: "#929292"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 20,
    width: 71,
    height: 8,
    rx: 4,
    fill: "#EDEDED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 31,
    width: 71,
    height: 8,
    rx: 4,
    fill: "#EDEDED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 42,
    width: 71,
    height: 8,
    rx: 4,
    fill: "#EDEDED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 53,
    width: 71,
    height: 8,
    rx: 4,
    fill: "#EDEDED"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFiltersIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filters-icon.9105a949120639f6ce0d9f480f0f7c0b.svg";